import React, {Component} from 'react';
import {getUserActivities} from '../../../api/profile/activities.js';
import {getUserMonthlyResults} from '../../../api/profile/monthlyResults.js';
import {getStravaConnection} from '../../../api/profile/stravaConnection.js';
import {endSync} from '../../../api/strava/sync.js';
import {getLastReport} from "../../../api/internal/report.js";

import DashboardHeader from '../DashboardHeader/DashboardHeader.js';
import PointsAndMoney from '../PointsAndMoney/PointsAndMoney.js';
import TimeAndDistance from '../TimeAndDistance/TimeAndDistance.js';
import UserActivitiesLog from '../UserActivitiesLog/UserActivitiesLog.js';
import UserStravaSynchronization from '../UserStravaSynchronization/UserStravaSynchronization.js';
import UserChart from '../UserChart/UserChart.js';

import './UserProfile.css';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stravaConnection: undefined,
      userActivities: [],
      monthlyResults: [],
      pointsAndMoney: {
        'points': 0,
        'money': 0
      },
      timeAndDistance:{
        'totalTime': 0,
        'totalDistance': 0,
      },
      lastReportMonth: 0,
      lastReportYear: 0
    }
  }

  setUserMonthlyResults = () => {
    getUserMonthlyResults()
      .then(
        (result) => {
          if(result.length > 0){
            this.setState({
              monthlyResults: result,
              pointsAndMoney: {
                'points': Math.floor(result[0].totalPoints),
                'money': 0
              },
              timeAndDistance:{
                'totalTime': Math.floor(result[0].totalDuration),
                'totalDistance': Math.floor(result[0].totalDistance),
              }
            });
          }
        },
        (error) => {console.error('setUserMonthlyResults() ERROR', error); }
      );
  }

  setStravaConnectionState = () => {
    getStravaConnection()
      .then(
        (result) => {
          this.setState({stravaConnection: result})
        },
        (error) => {console.error('setStravaConnectionState() ERROR', error); }
      );
  }

  setUserActivities = () => {
    var lastReportDate = new Date(`${this.state.lastReportYear}-${String(this.state.lastReportMonth).padStart(2, '0')}-01`);
    var thisMonthDate = new Date(lastReportDate.setMonth(lastReportDate.getMonth() + 1));
    
    let dd = '01';
    let mm = String(thisMonthDate.getMonth()+1).padStart(2, '0');
    let yyyy = String(thisMonthDate.getFullYear());

    getUserActivities(yyyy, mm, dd)
      .then(
        (result) => {
          this.setState({userActivities: result})
        },
        (error) => {
          this.setState({userActivities: []})
          console.error('[getActivities] Error:', error);
        }
      );
  }
  getLastReportDate = () =>{
    getLastReport()
      .then(
        (result) => {
          this.setState({
            lastReportMonth: result.month,
            lastReportYear: result.year
          })
          this.setUserActivities();
        },
        (error) => {
          console.log('getLastReportDate() - ERROR', error);
        }
      )
  }

  onDisconnectStravaHandler(){
    endSync()
      .catch((error)=>{
        console.error('onDisconnectStravaHandler() ERROR:', error);
      })
      .finally(()=>{
        this.setStravaConnectionState();
      });
  }
  updateProfile(){
    this.setUserMonthlyResults();
    this.setUserActivities();
  }

  render(){
    return (
      <React.Fragment>
        <DashboardHeader
          header="My profile"
          user={this.props.user}
        />
        <div className="Dashboard-content UserProfile">
          <div className="UserProfile-section">
            <div className="UserProfile-sectionHeader">
              Monthly results
            </div>
            <div>
              <UserChart
                monthlyResults={this.state.monthlyResults}
              />
            </div>
          </div>

          <div className="UserProfile-section">
            <div className="UserProfile-sectionHeader">
              Achieved this month
            </div>
            <div>
              <PointsAndMoney
                pointsAndMoney={this.state.pointsAndMoney}
              />
              <TimeAndDistance
                timeAndDistance={this.state.timeAndDistance}
              />
            </div>
          </div>

          <div className="UserProfile-section">
            <div className="UserProfile-sectionHeader">
              Activities log
            </div>
            <div>
              <UserActivitiesLog
                userActivities={this.state.userActivities}
                categories={this.props.categories}
                updateProfile={() => this.updateProfile()}
              />
            </div>
          </div>

          <div className="UserProfile-section">
            <div className="UserProfile-sectionHeader">
              &nbsp;
            </div>
            <div>
              <UserStravaSynchronization
                stravaConnection={this.state.stravaConnection}
                disconnectStrava={()=>this.onDisconnectStravaHandler()}
              />
            </div>
          </div>

        </div>
      </React.Fragment>
    );
  }

  componentDidMount(){
    this.getLastReportDate();
    this.setUserMonthlyResults();
    this.setStravaConnectionState();
  }

}
export default UserProfile;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/UserProfile/UserProfile.js